import React from 'react';
import { ActivityIndicator, View } from 'react-native';

import { useAuth } from '@hooks/auth';

import AppRoutes from './app.routes';

const Routes: React.FC = () => {
  const { token, loading } = useAuth();

  if (loading) {
    return (
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
        <ActivityIndicator size="large" color="#999" />
      </View>
    );
  }

  return <AppRoutes isLoggedIn={!!token} />;
};

export default Routes;
